import {
  compose,
  pure,
  withHandlers,
  withState,
  lifecycle,
  shallowEqual,
  renameProp,
} from 'recompose'
import * as R from 'ramda'
import toReduxFormField from '../../../enhancers/ToReduxFormField'
import { matchNumberOr } from './utils'

const enhance = compose(
  renameProp('onChange', 'onChangeCallback'),
  toReduxFormField('InputScore'),
  withState(
    'selectedValue',
    'updateSelectedValue',
    R.propOr(1, 'selectedValue'),
  ),
  withState('hoverValue', 'updateHoverValue', 1),
  withState('isHovering', 'updateIsHovering', false),
  withHandlers({
    handleSelect:
      ({
        selectedValue,
        updateSelectedValue,
        input,
        onChangeCallback = R.identity,
      }) =>
      rawScore => {
        const score = matchNumberOr(selectedValue)(rawScore)
        updateSelectedValue(score)
        onChangeCallback(score)
        input.onChange(score)
      },
    handleHover:
      ({ selectedValue, updateHoverValue, updateIsHovering }) =>
      rawScore => {
        const score = matchNumberOr(selectedValue)(rawScore)
        updateHoverValue(score)
        updateIsHovering(true)
      },
    handleHoverEnds:
      ({ selectedValue, updateHoverValue, updateIsHovering }) =>
      () => {
        updateHoverValue(selectedValue)
        updateIsHovering(false)
      },
  }),
  lifecycle({
    componentDidMount() {
      const initialValue = this.props.input.value || this.props.selectedValue
      this.props.updateSelectedValue(initialValue)
      this.props.input.onChange(initialValue)
    },
    componentDidUpdate(prevProps) {
      const prevValue = prevProps.input.value
      if (!shallowEqual(prevValue, this.props.input.value)) {
        this.props.updateSelectedValue(this.props.input.value)
      }
    },
  }),
  pure,
)

export default enhance
